import { render, staticRenderFns } from "./CareerAIJobCard.vue?vue&type=template&id=5dc924f6&scoped=true"
import script from "./CareerAIJobCard.vue?vue&type=script&lang=js"
export * from "./CareerAIJobCard.vue?vue&type=script&lang=js"
import style0 from "./CareerAIJobCard.vue?vue&type=style&index=0&id=5dc924f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc924f6",
  null
  
)

export default component.exports